var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-topo-treebox"},[_c('div',{staticClass:"h-gnb-pm-tree"},[_c('ejs-treeview',{ref:"pmGnbTopoTree",attrs:{"id":"pmGnbTopoTree","nodeSelected":_vm.nodeSelectedOfPmGnbTopoTree,"enablePersistence":true,"fields":_vm.pmGnbTopoTreeFields}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }